import React, { Fragment, useEffect, useState } from "react";
import 'src/scss/mfs.css';
import {
  CCol,
  CModal,
  CFormGroup,
  CInputCheckbox,
  CLabel,
  CModalBody,
  CModalFooter,
  CTextarea,
} from "@coreui/react";
import ApiHelper from "src/utils/api/api_helper";
import ApoCntrHdwtRegPop from "./apoCntrHdwtRegPop";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert";
import { setReqTaskInfo, setClearReqTaskInfo, setClearReqTaskInfo2, reqTaskInfo } from "../../modules/insert";
import { InputWrap } from "src/reusable";

const HdwtGuideCpnt = (props) => {
  let { 
    data,
    hdwtInfo,
    stCd,
  } = props;

  return (
    <>
      { data.length > 0
        &&
        data.map((item) => {
          return(
            <CFormGroup row className="signBtn" key={item.HDWT_CAT_CD}>
              <CCol xs="8" className="text-left">
                <CFormGroup variant="checkbox" className="checkbox">
                  <CInputCheckbox
                    id={item.HDWT_CAT_CD}
                    name={item.HDWT_CAT_CD}
                    checked={
                      hdwtInfo.filter((item2) => item2.hdwtCatCd === item.HDWT_CAT_CD)[0].data ? true : false
                    }
                    readOnly
                  />
                  <CLabel variant="checkbox" className="form-check-label">
                    <b>{item.HDWT_TEXT}</b>
                  </CLabel>
                </CFormGroup>
              </CCol>
              <CCol xs="4">
                <button className="btn-footer" type="button"
                  onClick={() => props.onOpen(item.HDWT_CAT_CD, item.SIGN_YN)}
                  disabled={
                    stCd === "10" ||
                    stCd === "99"
                      ? false
                      : true
                  }
                >
                  {item.SIGN_YN == 'Y' ? '서명하기' : '따라쓰기'}
                </button>
              </CCol>
            </CFormGroup>
          )
        })
      }
    </>
  )
}

const ApoCntrFormPop = (props) => {
  const dispatch = useDispatch();
  const appUrl = `${process.env.REACT_APP_API_HOST}`;
  const state = useSelector((state) => state);
  const { itmCd, mCheck } = props;
  const { finAcdntCorpNm, finAcdntKind, acdntDtm, acdntCtnt, acdntDtlCtnt, dissCorpNm, dissFinAcdntKind, dissDtm, dissDtlCtnt, financialStat, financial2Stat } = state.insert;
  // const title = props.title;
  // const imgName = {
  //   ACF01: ["APO_CNTR_FORM_01_A", "APO_CNTR_FORM_01_B"],
  //   ACF02: ["APO_CNTR_FORM_02_A", "APO_CNTR_FORM_02_B"],
  //   ACF03: ["APO_CNTR_FORM_03_A", "APO_CNTR_FORM_03_B"],
  //   ACF04: ["APO_CNTR_FORM_04_A", "APO_CNTR_FORM_04_B"],
  //   ACF05: ["APO_CNTR_FORM_05_A", "APO_CNTR_FORM_05_B"],
  // };
  const [files, setFiles] = useState([]);
  const [hdwtData, setHdwtData] = useState({});
  const [hdwtRegPop, setHdwtRegPop] = React.useState({
    isOpen: false,
    hdwtCatCd: 0,
    signYn: false
  });

  // 엠금융 금용사고 유무 display
  const [financial, setFinancial] = useState();
  const [financial2, setFinancial2] = useState();

  // ABA 선택적 정보 동의여부
  const [agreeYn, setAgreeYn] = useState();

  // 엠금융 금융사고 값들 담아주기
  const [finAcdn, setFinAcdn] = useState({
    finAcdntCorpNm: "",
    finAcdntKind: "",
    acdntDtm: "",
    acdntCtnt: "",
    acdntDtlCtnt: "",
  });

  const [finAcdn2, setFinAcdn2] = useState({
    dissCorpNm: "",
    dissFinAcdntKind: "",
    dissDtm: "",
    dissDtlCtnt: "",
  });

  useEffect(async () => {
    let params = {};

    params.itmCd = itmCd;
    
    await ApiHelper.request(
      ApiHelper.methods.get,
      "/cust/request/cntrFormItmFiles",
      params
    )
    .then(({ data }) => {
      if (data.status === "SUCCESS") {
        let result = data.data;
        
        params.fileSeqNoList = result.map((item) => item.FILE_SEQ_NO);

        setFiles(result);
      }
    })
    .catch((err) => {
      console.error(err);
    });

    await ApiHelper.request(
      ApiHelper.methods.get,
      "/cust/request/cntrFormItmFilesHdwtInfo",
      params
    )
    .then(({ data }) => {
      if (data.status === "SUCCESS") {
        let result = data.data;
        
        setHdwtData(result);
      }
    })
    .catch((err) => {
      console.error(err);
    });
  }, []);

  useEffect(() => {
    setFinancial(state.insert.reqTaskInfo.financialStat);
    setFinancial2(state.insert.reqTaskInfo.financial2Stat);
    setAgreeYn(state.insert.reqTaskInfo.agreeYn);
    setFinAcdn({
      finAcdntCorpNm: state.insert.reqTaskInfo.finAcdntCorpNm,
      finAcdntKind: state.insert.reqTaskInfo.finAcdntKind,
      acdntDtm: state.insert.reqTaskInfo.acdntDtm,
      acdntCtnt: state.insert.reqTaskInfo.acdntCtnt,
      acdntDtlCtnt: state.insert.reqTaskInfo.acdntDtlCtnt,
    })
    setFinAcdn2({
      dissCorpNm: state.insert.reqTaskInfo.dissCorpNm,
      dissFinAcdntKind: state.insert.reqTaskInfo.dissFinAcdntKind,
      dissDtm: state.insert.reqTaskInfo.dissDtm,
      dissDtlCtnt: state.insert.reqTaskInfo.dissDtlCtnt,
    })
  }, []);

  const handelConfirm = async() => { 
    const checks = document.querySelectorAll('.form-check-input');

    if(itmCd == 'AC045'){
      if(financial !== 'Y' && financial !== 'N'){
        return Swal({
          title: "금융사고",
          text: "금융사고 경력 유무를 체크해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      } else if(financial2 !== 'Y' && financial2 !== 'N'){
        return Swal({
          title: "금융사고",
          text: "금융사고 심의진행 유무를 체크해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
    }

    {/* ABA 선택적 정보 동의여부 체크 */}
    // 개발 : AC080 / 운영 : AC089
    if(itmCd == 'AC089'){
      if(agreeYn !== 'Y' && agreeYn !== 'N'){
        return Swal({
          title: "선택적 정보",
          text: "선택적 정보 수집·이용 동의 여부를 체크해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
    }

    if(financial == 'Y'){
      if(finAcdn.finAcdntCorpNm == "" || finAcdn.finAcdntCorpNm == undefined){
        return Swal({
          title: "금융사고",
          text: "금융사고 회사명 항목을 작성해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
      else if(finAcdn.finAcdntKind == "" || finAcdn.finAcdntKind == undefined){
        return Swal({
          title: "금융사고",
          text: "금융사고 유형 항목을 작성해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
      else if(finAcdn.acdntDtm == "" || finAcdn.acdntDtm == undefined){
        return Swal({
          title: "금융사고",
          text: "제재일자 항목을 작성해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
      else if(finAcdn.acdntCtnt == "" || finAcdn.acdntCtnt == undefined){
        return Swal({
          title: "금융사고",
          text: "제재내용 항목을 작성해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
      else if(finAcdn.acdntDtlCtnt == "" || finAcdn.acdntDtlCtnt == undefined){
        return Swal({
          title: "금융사고",
          text: "금융사고 관련내용 기술 항목을 작성해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
    }
    
    if(financial2 == 'Y'){
      if(finAcdn2.dissCorpNm == "" || finAcdn2.dissCorpNm == undefined){
        return Swal({
          title: "심의진행",
          text: "심의진행 회사명 항목을 작성해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
      else if(finAcdn2.dissFinAcdntKind == "" || finAcdn2.dissFinAcdntKind == undefined){
        return Swal({
          title: "심의진행",
          text: "심의중인 금융사고 유형 항목을 작성해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
      else if(finAcdn2.dissDtm == "" || finAcdn2.dissDtm == undefined){
        return Swal({
          title: "심의진행",
          text: "발생 일 항목을 작성해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
      else if(finAcdn2.dissDtlCtnt == "" || finAcdn2.dissDtlCtnt == undefined){
        return Swal({
          title: "심의진행",
          text: "심의중인 관련내용 기술 항목을 작성해주세요.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
    }

    for(let item of checks) {
      if(!item.checked) {
        return Swal({
          title: "위촉계약서",
          text: "문서내 서명을 모두 작성해야합니다.",
          icon: "info",
          buttons: {
            catch: { text: "취소", value: false },
            default: { text: "확인", value: true },
          },
        })
      }
    }
    // 유무 여부 저장
    await dispatch(setReqTaskInfo({financialStat: financial}, true));
    await dispatch(setReqTaskInfo({financial2Stat: financial2}, true));

    await dispatch(setReqTaskInfo({agreeYn: agreeYn}, true));

    // '있다' 선택했을 때 값들 저장
    await dispatch(setReqTaskInfo(finAcdn, true));
    await dispatch(setReqTaskInfo(finAcdn2, true));
    // '없다' 선택하면 저장된 값들 리셋
    if(itmCd == 'AC045' && financial == 'N'){
      await dispatch(setClearReqTaskInfo());
    } 
    if(itmCd == 'AC045' && financial2 == 'N'){
      await dispatch(setClearReqTaskInfo2());
    }
    return props.onClose(); 
  }
  
  // 엠금융 금융사고 관련 정보 담기
  const handleInputChange = async(e) => {
    let { name, value } = e.target;
    
    setFinAcdn({
      ...finAcdn,
      [e.target.name] : e.currentTarget.value});
    setFinAcdn2({
      ...finAcdn2,
      [e.target.name] : e.currentTarget.value});
    
    await dispatch(setReqTaskInfo(finAcdn, true));
    await dispatch(setReqTaskInfo(finAcdn2, true));
  }
  
  // const handelConfirm = () => {
  //   const checkItems = state.apoCntrForm.apoCntrHdwtInfo;
  //   for (let i = 0; i < checkItems.length; i++) {
  //     if (title === "apoCntrForm1" && (i === 0 || i === 1)) {
  //       if (checkItems[i].data === "" || checkItems[i].data === undefined) {
  //         return Swal({
  //           title: "위촉계약서",
  //           text: "문서내 서명을 작성해야합니다.",
  //           icon: "info",
  //           buttons: {
  //             catch: { text: "취소", value: false },
  //             default: { text: "확인", value: true },
  //           },
  //         }).then((value) => {
  //           if (value === false) props.onClose();
  //         });
  //       }
  //     } else if (title === "apoCntrForm2" && i === 2) {
  //       if (checkItems[i].data === "" || checkItems[i].data === undefined) {
  //         return Swal({
  //           title: "위촉계약서",
  //           text: "문서내 서명을 작성해야합니다.",
  //           icon: "info",
  //           buttons: {
  //             catch: { text: "취소", value: false },
  //             default: { text: "확인", value: true },
  //           },
  //         }).then((value) => {
  //           if (value === false) props.onClose();
  //         });
  //       }
  //     } else if (title === "apoCntrForm3" && i === 3) {
  //       if (checkItems[i].data === "" || checkItems[i].data === undefined) {
  //         return Swal({
  //           title: "위촉계약서",
  //           text: "문서내 서명을 작성해야합니다.",
  //           icon: "info",
  //           buttons: {
  //             catch: { text: "취소", value: false },
  //             default: { text: "확인", value: true },
  //           },
  //         }).then((value) => {
  //           if (value === false) props.onClose();
  //         });
  //       }
  //     } else if (title === "apoCntrForm4" && i === 4) {
  //       if (checkItems[i].data === "" || checkItems[i].data === undefined) {
  //         return Swal({
  //           title: "위촉계약서",
  //           text: "문서내 서명을 작성해야합니다.",
  //           icon: "info",
  //           buttons: {
  //             catch: { text: "취소", value: false },
  //             default: { text: "확인", value: true },
  //           },
  //         }).then((value) => {
  //           if (value === false) props.onClose();
  //         });
  //       }
  //     } else if (title === "apoCntrForm5" && i === 5) {
  //       if (checkItems[i].data === "" || checkItems[i].data === undefined) {
  //         return Swal({
  //           title: "위촉계약서",
  //           text: "문서내 서명을 작성해야합니다.",
  //           icon: "info",
  //           buttons: {
  //             catch: { text: "취소", value: false },
  //             default: { text: "확인", value: true },
  //           },
  //         }).then((value) => {
  //           if (value === false) props.onClose();
  //         });
  //       }
  //     }
  //   }
  //   props.onClose();
  // };

  function onOpen(code, signYn) {
    setHdwtRegPop({
      isOpen: true,
      hdwtCatCd: code,
      signYn: signYn
    })
  }

  let finStat;
  let finStat2;
  // 금융사고 경력 유무 우선순위 부여
  if(financial == 'Y'){
    finStat = 'Y';
  } else if(financial == 'N'){
    finStat = 'N';
  } else if(state.insert.reqTaskInfo.financialStat == 'Y'){
    finStat = 'Y';
  } else {finStat = 'N';}

  // 심의진행 유무 우선순위 부여
  if(financial2 == 'Y'){
    finStat2 = 'Y';
  } else if(financial2 == 'N'){
    finStat2 = 'N';
  } else if(state.insert.reqTaskInfo.financial2Stat == 'Y'){
    finStat2 = 'Y';
  } else {finStat2 = 'N';}

  return (
    <>
      <CModal
        className={hdwtRegPop.isOpen ? "hideContent" : "showContent"}
        show={true}
        size="lg"
        closeOnBackdrop={false}
        onClosed={() => {
          props.onClose();
        }}
      >
        <CModalBody className="apoModalBody">
          { files.length > 0
            &&
            files.map((item) => {
              return (
                <Fragment key={item.FILE_SEQ_NO}>
                  <CFormGroup row>
                    <img
                      src={`${appUrl}cust/request/getImages/apoCntrForm?${item.MNG_FILE_NM}`}
                      alt={itmCd}
                      width="100%"
                    />
                  </CFormGroup>
                  { 
                    Object.keys(hdwtData).length !== 0
                    &&
                    hdwtData[item.FILE_SEQ_NO].length > 0
                    &&
                    <HdwtGuideCpnt 
                      data={hdwtData[item.FILE_SEQ_NO]}
                      hdwtInfo={state.apoCntrForm.apoCntrHdwtInfo}
                      stCd={state.insert.reqTaskInfo.stCd}
                      onOpen={onOpen}
                    >
                    </HdwtGuideCpnt>
                  }
                  { item.FILE_SEQ_NO == '96' &&
                  <>
                    <>
                      <h5 className="check-title">
                        ▶&nbsp;직전회사에서 금융사고 경력 유무
                      </h5>
                      <span className="check-span"></span>
                      {/* <!-- 라디오 인풋 --> */}
                      <div className="radioBox-wrapper">
                          <div className="radioBox-container">
                              <label name="check" id="radio-checkBox">
                                  <input type="radio" id="radio-cb" name="radio" value={financial == 'Y' && 'Y'} checked={financial == 'Y' && 'Y'} onChange={() => setFinancial('Y')} />
                                  <span htmlFor="radio-cb"></span>
                                  <p className="checkTitle">있다</p>
                              </label>
                              <label name="check" id="radio-checkBox">
                                  <input type="radio" id="radio-cb" name="radio" value={financial == 'N' && 'Y'}  checked={financial == 'N' && 'Y'} onChange={() => setFinancial('N')} />
                                  <span htmlFor="radio-cb"></span>
                                  <p className="checkTitle">없다</p>
                              </label>
                          </div>
                      </div>
                      { finStat == 'Y' &&
                      <>
                        <div className="input-write-Box">
                          <span className="input-name">금융사고 회사명</span>
                          <input 
                            type="text"
                            className="input-write reg-cust-input"
                            id="finAcdntCorpNm"
                            name="finAcdntCorpNm"
                            value={finAcdn.finAcdntCorpNm}
                            maxLength={50}
                            onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-write-Box">
                          <span className="input-name">금융사고 유형</span>
                          <input 
                            type="text"
                            className="input-write reg-cust-input"
                            id="finAcdntKind"
                            name="finAcdntKind"
                            value={finAcdn.finAcdntKind}
                            maxLength={50}
                            onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-write-Box">
                          <span className="input-name">제재 일자</span>
                          <input 
                            type="text"
                            className="input-write reg-cust-input"
                            id="acdntDtm"
                            name="acdntDtm"
                            value={finAcdn.acdntDtm}
                            placeholder="예시: 2023년 1월 1일"
                            maxLength={20}
                            onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-write-Box">
                          <span className="input-name">제재 내용</span>
                          <input 
                            type="text"
                            className="input-write reg-cust-input"
                            id="acdntCtnt"
                            name="acdntCtnt"
                            value={finAcdn.acdntCtnt}
                            maxLength={50}
                            onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-write-Box">
                        <InputWrap size={12} prepend="금융사고 관련내용 기술">
                          <CTextarea
                            type="text"
                            className="input-write reg-cust-input-long"
                            id="acdntDtlCtnt"
                            name="acdntDtlCtnt"
                            size="7"
                            rows="5"
                            value={finAcdn.acdntDtlCtnt}
                            maxLength={500}
                            onChange={handleInputChange}
                            />
                        </InputWrap>
                        </div>
                        <div>주&#41; 금융사고 경력이란 등록취소 조치가 완료된 경우를 의미하는 것이 아니라 보험사 등에서<br/>
                             자체규정 등에 따라 금융사고자로 제재절차를 완료한 후 금감원에 금융사고 건으로 보고한 경우를 말함<br/><br/><br/>
                        </div>
                      </>
                      }
                    </>
                    <>
                      <h5 className="check-title">
                        ▶&nbsp;직전회사에서 금융사고로 현재 심의진행 유무
                      </h5>
                      <span className="check-span"></span>
                      {/* <!-- 라디오 인풋 --> */}
                      <div className="radioBox-wrapper">
                          <div className="radioBox-container">
                              <label name="check" id="radio-checkBox">
                                  <input type="radio" id="radio-cb" name="radio2" value={financial2 == 'Y' && 'Y'} checked={financial2 == 'Y' && 'Y'} onChange={() => setFinancial2('Y')} />
                                  <span htmlFor="radio-cb"></span>
                                  <p className="checkTitle">있다</p>
                              </label>
                              <label name="check" id="radio-checkBox">
                                  <input type="radio" id="radio-cb" name="radio2" value={financial2 == 'N' && 'Y'} checked={financial2 == 'N' && 'Y'} onChange={() => setFinancial2('N')} />
                                  <span htmlFor="radio-cb"></span>
                                  <p className="checkTitle">없다</p>
                              </label>
                          </div>
                      </div>
                      { finStat2 == 'Y' &&
                      <>
                        <div className="input-write-Box">
                          <span className="input-name">심의진행 회사명</span>
                          <input 
                            type="text"
                            className="input-write reg-cust-input"
                            id="dissCorpNm"
                            name="dissCorpNm"
                            value={finAcdn2.dissCorpNm}
                            maxLength={50}
                            onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-write-Box">
                          <span className="input-name">심의중인 금융사고 유형</span>
                          <input 
                            type="text"
                            className="input-write reg-cust-input"
                            id="dissFinAcdntKind"
                            name="dissFinAcdntKind"
                            value={finAcdn2.dissFinAcdntKind}
                            maxLength={50}
                            onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-write-Box">
                          <span className="input-name">발생 일</span>
                          <input 
                            type="text"
                            className="input-write reg-cust-input"
                            id="dissDtm"
                            name="dissDtm"
                            value={finAcdn2.dissDtm}
                            placeholder="예시: 2023년 1월 1일"
                            maxLength={20}
                            onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-write-Box">
                        <InputWrap size={12} prepend="심의중인 관련내용 기술">
                          <CTextarea
                            type="text"
                            className="input-write reg-cust-input-long"
                            id="dissDtlCtnt"
                            name="dissDtlCtnt"
                            size="7"
                            rows="5"
                            value={finAcdn2.dissDtlCtnt}
                            maxLength={500}
                            onChange={handleInputChange}
                            />
                        </InputWrap>
                        </div>
                      </>
                      }
                    </>
                    </>
                  }
                  {/* ABA 선택적 정보 동의여부 체크 */}
                  {/* 개발 : 148 / 운영 : 194 */}
                  { item.FILE_SEQ_NO == '194' &&
                    <>
                      <h5 className="check-title">
                        ■&nbsp;선택적 정보 수집&#183;이용 동의
                      </h5>
                      <span className="check-span"></span>
                      {/* <!-- 라디오 인풋 --> */}
                      <div className="radioBox-wrapper">
                          <div className="radioBox-container">
                              <label name="check" id="radio-checkBox" style={{display:"inline", marginRight:"1.5rem"}}>
                                  <input type="radio" id="radio-cb" name="radio" value={agreeYn == 'Y'} checked={agreeYn == 'Y'} onChange={() => setAgreeYn('Y')} />
                                  <span htmlFor="radio-cb"></span>
                                  <p className="checkTitle">동의함</p>
                              </label>
                              <label name="check" id="radio-checkBox" style={{display:"inline"}}>
                                  <input type="radio" id="radio-cb" name="radio" value={agreeYn == 'N'} checked={agreeYn == 'N'} onChange={() => setAgreeYn('N')} />
                                  <span htmlFor="radio-cb"></span>
                                  <p className="checkTitle">동의하지 않음</p>
                              </label>
                          </div>
                      </div>
                    </>
                  }
                </Fragment>
              )
            })
          }
          
          {/* {title === "apoCntrForm1" ? (
            <>
              <CFormGroup row className="signBtn">
                <CCol xs="8" className="text-left">
                  <CFormGroup variant="checkbox" className="checkbox">
                    <CInputCheckbox
                      id={`${title}chk_1`}
                      name={`${title}chk_1`}
                      checked={
                        state.apoCntrForm.apoCntrHdwtInfo[0].data ? true : false
                      }
                      readOnly
                    />
                    <CLabel variant="checkbox" className="form-check-label">
                      <b>충분히 이해하고 숙지하였습니다.</b>
                    </CLabel>
                  </CFormGroup>
                </CCol>
                <CCol xs="4">
                  <button className="btn-footer" type="button"
                    onClick={() =>
                      setHdwtRegPop({
                        isOpen: true,
                        index: 0,
                      })
                    }
                    disabled={
                      state.insert.reqTaskInfo.stCd === "10" ||
                      state.insert.reqTaskInfo.stCd === "99"
                        ? false
                        : true
                    }
                  >
                    서명하기
                  </button>
                </CCol>
              </CFormGroup>
              <CFormGroup row className="signBtn">
                <CCol xs="8" className="text-left">
                  <CFormGroup variant="checkbox" className="checkbox">
                    <CInputCheckbox
                      id={`${title}chk_2`}
                      name={`${title}chk_2`}
                      checked={
                        state.apoCntrForm.apoCntrHdwtInfo[1].data ? true : false
                      }
                      readOnly
                    />
                    <CLabel variant="checkbox" className="form-check-label">
                      <b>위촉계약서 부본을 수령 하였습니다.</b>
                    </CLabel>
                  </CFormGroup>
                </CCol>
                <CCol xs="4">
                  <button className="btn-footer" type="button"
                    onClick={() =>
                      setHdwtRegPop({
                        isOpen: true,
                        index: 1,
                      })
                    }
                    disabled={
                      state.insert.reqTaskInfo.stCd === "10" ||
                      state.insert.reqTaskInfo.stCd === "99"
                        ? false
                        : true
                    }
                  >
                    서명하기
                  </button>
                </CCol>
              </CFormGroup>
            </>
          ) : (
            <>
              <CFormGroup row className="signBtn">
                <CCol xs="8" className="text-left">
                  <CFormGroup variant="checkbox" className="checkbox">
                    {title === "apoCntrForm2" && (
                      <CInputCheckbox
                        id={`${title}chk`}
                        name={`${title}chk`}
                        checked={
                          state.apoCntrForm.apoCntrHdwtInfo[2].data
                            ? true
                            : false
                        }
                        readOnly
                      />
                    )}
                    {title === "apoCntrForm3" && (
                      <CInputCheckbox
                        id={`${title}chk`}
                        name={`${title}chk`}
                        checked={
                          state.apoCntrForm.apoCntrHdwtInfo[3].data
                            ? true
                            : false
                        }
                        readOnly
                      />
                    )}
                    {title === "apoCntrForm4" && (
                      <CInputCheckbox
                        id={`${title}chk`}
                        name={`${title}chk`}
                        checked={
                          state.apoCntrForm.apoCntrHdwtInfo[4].data
                            ? true
                            : false
                        }
                        readOnly
                      />
                    )}
                    {title === "apoCntrForm5" && (
                      <CInputCheckbox
                        id={`${title}chk`}
                        name={`${title}chk`}
                        checked={
                          state.apoCntrForm.apoCntrHdwtInfo[5].data
                            ? true
                            : false
                        }
                        readOnly
                      />
                    )}

                    <CLabel variant="checkbox" className="form-check-label">
                      <b>
                        {title === "apoCntrForm2"
                          ? "상기 내용을 잘 이해하고 숙지했습니다."
                          : title === "apoCntrForm3"
                          ? "상기 내용에 대하여 충분히 이해 하였습니다."
                          : "서명"}
                      </b>
                    </CLabel>
                  </CFormGroup>
                </CCol>
                <CCol xs="4">
                  <button className="btn-footer" type="button"
                    onClick={() =>
                      setHdwtRegPop({
                        isOpen: true,
                        index:
                          title === "apoCntrForm2"
                            ? 2
                            : title === "apoCntrForm3"
                            ? 3
                            : title === "apoCntrForm4"
                            ? 4
                            : 5,
                      })
                    }
                    disabled={
                      state.insert.reqTaskInfo.stCd === "10" ||
                      state.insert.reqTaskInfo.stCd === "99"
                        ? false
                        : true
                    }
                  >
                    서명하기
                  </button>
                </CCol>
              </CFormGroup>
            </>
          )} */}
          
          {/* <CFormGroup row>
            <img
              src={`/images/apoCntrForm/${imgName[title][1]}.png`}
              alt={imgName[title][1]}
              width="100%"
            />
          </CFormGroup> */}
        </CModalBody>
        <CModalFooter>
          <div className="layout-footer">
            <button className="btn-footer" type="button" 
              onClick={
                state.insert.reqTaskInfo.stCd === "10" ||
                state.insert.reqTaskInfo.stCd === "99"
                ? handelConfirm
                // ? (itmCd != 'AC046' ? handelConfirm : mCheck(true),handelConfirm)
                : () => props.onClose()
              }>
                확인
            </button>
          </div>
        </CModalFooter>
      </CModal>
      {hdwtRegPop.isOpen && (
        <ApoCntrHdwtRegPop
          modal={true}
          hdwtCatCd={hdwtRegPop.hdwtCatCd}
          signYn={hdwtRegPop.signYn}
          display={hdwtRegPop.isOpen ? "display" : ""}
          onClose={() => setHdwtRegPop({ isOpen: false })}
        ></ApoCntrHdwtRegPop>
      )}
    </>
  );
};

export default ApoCntrFormPop;
